import React from "react";

const PageNotFound = () => {
    return (
		<div className="min-h-screen bg-white flex items-center justify-center p-4">
			<div className="max-w-md text-center">
				<h1 className="text-4xl font-bold text-gray-800 mb-4">404 - Page Not Found</h1>
				<p className="text-gray-600 mb-6">
					The page you are looking for does not exist.
				</p>

                <p className="text-gray-600">
					If you need more assistance, please contact our team:
					<br/>
					<a href="mailto:info@biorev.us" className="text-blue-600 hover:underline font-medium">
						info@biorev.us
					</a>
				</p>
			</div>
		</div>
	); 
};

export default PageNotFound;